<template>
  <v-card>
    <v-snackbar v-model="msg" centered
      >{{ text }}
      <v-btn color="pink" text @click="msg = false"> Close</v-btn>
    </v-snackbar>
    <v-card-title style="background-color: #2b3990" class="white--text pa-4">
      <v-icon class="white--text">mdi-pencil</v-icon> &nbsp;&nbsp;
      <span class="headline" v-html="selectedShift?.name"></span>
    </v-card-title>
    <v-form ref="form" lazy-validation>
      <v-card-text>
        <v-container fluid>
          <v-row>
            <v-col class="d-flex" cols="12" md="4">
              <v-row>
                <v-col cols="12" lg="12" md="12">
                  <DatePicker
                    label="Start Shift"
                    v-model="startShiftDate"
                    :default-date="startShiftDateProps"
                    :isDisabledElemsOnStaff="isDisabledElementsOnStaff()"
                  />
                  <TimePicker
                    v-model="startShiftTime"
                    labelHour="Start Shift Hour"
                    labelMinute="Start Shift Minute"
                    :default-time="startShiftTimeProps"
                    :isDisabledElemsOnStaff="isDisabledElementsOnStaff()"
                  />
                </v-col>
                <v-col cols="12" lg="12" md="12">
                  <DatePicker
                    label="End Shift"
                    v-model="endShiftDate"
                    :default-date="endShiftDateProps"
                    :isDisabledElemsOnStaff="isDisabledElementsOnStaff()"
                  />
                  <TimePicker
                    v-model="endShiftTime"
                    labelHour="End Shift Hour"
                    labelMinute="End Shift Minute"
                    :default-time="endShiftTimeProps"
                    :isDisabledElemsOnStaff="isDisabledElementsOnStaff()"
                  />
                </v-col>
                <v-container fluid>
                  <p>Recurring Events?</p>
                  <v-radio-group
                    v-model="isRecurringEvent"
                    :value="isRecurringEvent"
                    :disabled="isDisabledElementsOnStaff()"
                  >
                    <v-radio label="Yes" value="Yes"></v-radio>
                    <v-radio label="No" value="No"></v-radio>
                  </v-radio-group>
                </v-container>

                <v-col cols="12" md="6" v-if="isRecurringEvent === 'Yes'">
                  <v-select
                    :items="optionsForRecurring"
                    label="More"
                    v-model="selectedOption"
                    outlined
                    :disabled="isDisabledElementsOnStaff()"
                  ></v-select>
                </v-col>

                <v-container fluid>
                  <p>Is this for a training?</p>
                  <v-radio-group v-model="isForTraining" mandatory>
                    <v-radio label="Yes" value="Yes"></v-radio>
                    <v-radio label="No" value="No"></v-radio>
                  </v-radio-group>
                </v-container>

                <v-col class="d-flex" cols="12" sm="12">
                  <v-autocomplete
                    v-model="HouseId"
                    :items="houses"
                    item-text="Name"
                    item-value="_id"
                    label="Program"
                    required
                    :error-messages="houseErrors"
                    @input="$v.HouseId.$touch()"
                    @blur="$v.HouseId.$touch()"
                    :disabled="isDisabledElementsOnStaff()"
                  ></v-autocomplete>
                </v-col>
                <v-col class="d-flex" cols="12" sm="12">
                  <v-select
                    v-if="typeof ServiceCode === 'object'"
                    :items="clientsUnderSelectedProgram"
                    item-text="Name"
                    item-value="_id"
                    label="Client(s)"
                    v-model="ClientId"
                    required
                    :error-messages="clientErrors"
                    @input="$v.ClientId.$touch()"
                    @blur="$v.ClientId.$touch()"
                    :rules="[
                      (value) =>
                        (value && value.length > 0) || 'Client(s) is required',
                    ]"
                    multiple
                    @change="getTasks()"
                    :disabled="isDisabledElementsOnStaff()"
                  >
                    <template v-slot:selection="{ item }">
                      <v-menu bottom offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <v-chip
                            v-bind="attrs"
                            v-on="on"
                            class="px-0"
                            @click="selectedClientServiceCode(item._id)"
                          >
                            <v-tooltip right>
                              <template v-slot:activator="{ on, attrs }">
                                <v-container
                                  fluid
                                  class="px-0"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  <span class="ms-3">{{ item.Name }}</span>
                                  <v-icon class="mx-1">mdi-menu-down</v-icon>
                                </v-container>
                              </template>
                              <span
                                >Click to select
                                {{ item.Name }}
                                service code</span
                              >
                            </v-tooltip>
                          </v-chip>
                        </template>
                        <v-list>
                          <v-list-item-group>
                            <div
                              v-if="servicecodeListLoader"
                              class="text-center"
                            >
                              <v-progress-circular
                                :size="25"
                                :width="3"
                                indeterminate
                                color="secondary"
                              ></v-progress-circular>
                            </div>
                            <v-list-item
                              v-else-if="
                                servicecodesUnderSelectedClient.length <= 0
                              "
                              disabled
                            >
                              <v-list-item-content>
                                <v-list-item-title
                                  >No Service Code</v-list-item-title
                                >
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item
                              v-else
                              v-for="(
                                servicecodeItem, index
                              ) in servicecodesUnderSelectedClient"
                              :key="index"
                            >
                              <v-list-item-content
                                @click="
                                  checkSeletedServiceCode(servicecodeItem)
                                "
                              >
                                <v-list-item-title>{{
                                  servicecodeItem.servicecode_name
                                }}</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list-item-group>
                        </v-list>
                      </v-menu>
                    </template>
                  </v-select>
                  <v-select
                    v-else
                    :items="clientsUnderSelectedProgram"
                    item-text="Name"
                    item-value="_id"
                    label="Client(s)"
                    v-model="ClientId"
                    required
                    :error-messages="clientErrors"
                    @input="$v.ClientId.$touch()"
                    @blur="$v.ClientId.$touch()"
                    :rules="[
                      (value) =>
                        (value && value.length > 0) || 'Client(s) is required',
                    ]"
                    multiple
                    @change="getTasks()"
                    :disabled="isDisabledElementsOnStaff()"
                  ></v-select>
                </v-col>
                <v-col
                  class="d-flex"
                  cols="12"
                  md="12"
                  v-if="isForTraining === 'No'"
                >
                  <v-select
                    v-if="typeof ServiceCode === 'object'"
                    :items="serviceCodes"
                    :item-text="
                      (item) => `${item.servicecode_name} (${item.client_name})`
                    "
                    label="Service Code"
                    v-model="ServiceCode"
                    required
                    multiple
                    return-object
                    :error-messages="ServiceCodeErrors"
                    @input="$v.ServiceCode.$touch()"
                    @blur="$v.ServiceCode.$touch()"
                    :disabled="isDisabledElementsOnStaff()"
                    readonly
                  >
                  </v-select>
                  <v-select
                    v-else
                    :items="serviceCodes"
                    item-text="Name"
                    item-value="_id"
                    label="Service Code"
                    v-model="ServiceCode"
                    required
                    :error-messages="ServiceCodeErrors"
                    @input="$v.ServiceCode.$touch()"
                    @blur="$v.ServiceCode.$touch()"
                    :disabled="isDisabledElementsOnStaff()"
                  />
                </v-col>
                <v-col cols="12" md="12">
                  <v-textarea
                    v-model="notes"
                    outlined
                    label="Notes"
                    value=""
                    :disabled="isDisabledElementsOnStaff()"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-col>
            <v-col class="d-flex" cols="12" md="4">
              <v-container fluid>
                <v-radio-group v-model="task">
                  <template v-slot:label>
                    <h3 class="text-center">
                      <strong>Assign Task</strong>
                    </h3>
                  </template>
                  <v-container v-for="task in tasks" :key="task._id">
                    <v-radio
                      :value="task.Event"
                      :disabled="isDisabledElementsOnStaff()"
                    >
                      <template v-slot:label>
                        <span>{{ task.Event }}</span>
                      </template>
                    </v-radio>
                  </v-container>
                </v-radio-group>
              </v-container>
            </v-col>
            <v-col class="d-flex" cols="12" md="4">
              <!--PUT THE ADDITIONAL INFORMATION--->
              <v-col cols="12" md="12" v-if="isShowing">
                <v-card class="mb-3" max-width="">
                  <v-list class="overflow-y-auto" height="">
                    <v-subheader>
                      <h3>Last Modified</h3>
                    </v-subheader>
                    <v-list-item>
                      <v-list-item-title
                        :style="{
                          color: staffRequiresSupervision ? 'red' : '',
                        }"
                      >
                        {{ updatedByUser }}
                      </v-list-item-title>
                      <v-list-item-description>
                        {{ updatedDate }}
                      </v-list-item-description>
                    </v-list-item>
                  </v-list>
                </v-card>

                <v-card class="mb-3">
                  <v-list class="overflow-y-auto" height="200">
                    <v-subheader>
                      <h3>History</h3>
                    </v-subheader>
                    <v-list-item
                      v-for="(log, index) in updateLogs"
                      :key="index"
                      class="d-flex flex-column"
                    >
                      <v-list-item-title>
                        <strong>{{ log.modifiedByName }}</strong>
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        {{ formatDate(log.date) }}
                      </v-list-item-subtitle>
                      <v-list-item-description>
                        <v-row>
                          <v-col cols="4">
                            <strong>Field</strong>
                          </v-col>
                          <v-col cols="4">
                            <strong>Old Value</strong>
                          </v-col>
                          <v-col cols="4">
                            <strong>New Value</strong>
                          </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-row
                          v-for="(change, index2) in log.changes"
                          :key="index2"
                        >
                          <v-col cols="4">
                            {{ change.field }}
                          </v-col>
                          <v-col cols="4">
                            <span v-if="isDate(change.oldValue)">
                              {{ formatDate(change.oldValue) }}
                            </span>
                            <span v-else>
                              {{ change.oldValue }}
                            </span>
                          </v-col>
                          <v-col cols="4">
                            <span v-if="isDate(change.newValue)">
                              {{ formatDate(change.newValue) }}
                            </span>
                            <span v-else>
                              {{ change.newValue }}
                            </span>
                          </v-col>
                        </v-row>
                      </v-list-item-description>
                    </v-list-item>
                  </v-list>
                </v-card>

                <v-card class="" max-width="">
                  <v-list class="overflow-y-auto" height="">
                    <v-subheader>
                      <h3>Assigned Staff</h3>
                    </v-subheader>
                    <v-list-item>
                      <v-list-item-title
                        :style="{
                          color: staffRequiresSupervision ? 'red' : '',
                        }"
                      >
                        {{ staffName }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-card>
                <v-card
                  class="mt-3 pa-4 overflow-y-auto overflow-x-auto"
                  height="35vh"
                >
                  <v-card-title>Available</v-card-title>
                  <v-divider></v-divider>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    clearable
                    flat
                    solo-inverted
                    hide-details
                    prepend-inner-icon="search"
                    label="search"
                    class="desktop"
                  ></v-text-field>
                  <v-spacer></v-spacer>
                  <v-container fluid>
                    <v-radio-group
                      v-model="staffSelected"
                      :rules="[(v) => !!v || 'Staff is required']"
                      required
                      :disabled="isDisabledElementsOnStaff()"
                      @change="checkSupervision"
                    >
                      <div
                        v-for="available in resultQueryStaff"
                        :key="available._id"
                      >
                        <v-radio :value="available" class="mb-6">
                          <template v-slot:label>
                            <div
                              :style="{
                                color: available.RequiresSupervision
                                  ? 'red'
                                  : '',
                              }"
                            >
                              {{ available.Name }}
                              <v-icon v-if="available.MedCertified" small
                                >verified_user
                              </v-icon>
                              <v-icon v-if="available.FirstAid" small
                                >local_hospital
                              </v-icon>

                              <v-icon
                                small
                                style="position: absolute; right: 0"
                              >
                                mdi-phone
                              </v-icon>
                            </div>
                          </template>
                        </v-radio>
                      </div>
                    </v-radio-group>
                  </v-container>
                </v-card>
                <v-card class="mt-3 pa-2" max-width="">
                  <v-list class="overflow-y-auto" height="40vh">
                    <v-subheader>
                      <h3>Schedule in this Date</h3>
                    </v-subheader>
                    <v-list-item
                      v-for="(schedule, i) in scheduledStaff"
                      :key="i"
                      :value="schedule.staffId"
                    >
                      <v-list-item-title
                        :style="{
                          color: schedule.staffRequiresSupervision ? 'red' : '',
                        }"
                      >
                        {{ schedule?.staffName }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-col>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions v-if="this.isDisabledElemsOnStaff">
        <v-btn
          v-show="staffCanDelete"
          class="red darken-2 white--text"
          text
          @click="deleteShift(selectedShift.shiftId)"
          :loading="delShift_btn_loader"
          :disabled="delShift_btn_loader"
        >
          Delete
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          v-if="selectedShift.status === '0'"
          class="blue darken-2 white--text"
          text
          @click="publishScheduleShift()"
          :loading="updateShift_btn_loader"
          :disabled="updateShift_btn_loader"
        >
          Publish
        </v-btn>
        <v-btn
          v-else
          v-show="staffCanEdit"
          class="blue darken-2 white--text"
          text
          @click="updateScheduleShift()"
          :loading="updateShift_btn_loader"
          :disabled="updateShift_btn_loader"
        >
          Update
        </v-btn>
        <v-btn text color="blue darken-1" @click="close()">Back</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import axios from "axios";
import moment from "moment";
import moment_timezone from "moment-timezone";
import { mapMutations, mapState } from "vuex";

const url = require("../../client_config/config").url;
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import TimePicker from "@/components/DateTimePickers/TimePicker.vue";
import DatePicker from "@/components/DateTimePickers/DatePicker.vue";
import Swal from "sweetalert2";
import { cloneDeep } from "lodash";

export default {
  components: { DatePicker, TimePicker },
  mixins: [validationMixin],
  validations: {
    //: { required },
    HouseId: { required },
    ClientId: { required },
    ServiceCode: { required },
  },
  data: () => ({
    titleForm: "UPDATE",
    msg: false,
    text: "",
    color: "success",
    StaffId: null,
    Supervisor: null,
    isForTraining: "No",
    isRecurringEvent: "",
    calendarMenu: false,
    calendar2Menu: false,
    optionsForRecurring: ["Daily", "Weekly", "Monthly", "Annually"],
    selectedOption: "",
    search: null,
    staffSelected: null,
    staffSelectedForMeeting: "",
    ClientId: null,
    HouseId: 0,
    notes: "",
    status: 0,
    startDatetime: new Date(),
    clientsUnderSelectedProgram: [],
    endDatetime: new Date(
      new Date().setTime(new Date().getTime() + 1 * 60 * 60 * 1000)
    ),
    textFieldProps: {
      appendIcon: "event",
    },
    startDateProps: {
      //min: moment(new Date()).format("YYYY-MM-DD")
    },
    startTimeProps: {
      ampmInTitle: true,
    },
    endDateProps: {},
    endTimeProps: {},
    availableStaff: [],
    scheduledStaff: [],
    availableStaffinTraining: [],
    scheduledStaffinTraining: [],
    isShowing: true,
    staffName: "",
    assignedTask: "",
    tasks: [],
    task: null,
    requiredField: "",
    date: null,
    HouseName: [],
    ServiceCode: [],
    serviceCodes: [],
    servicecodesUnderSelectedClient: [],
    ClientServiceCode: [],

    delShift_btn_loader: false,
    updateShift_btn_loader: false,
    userState: localStorage.getItem("userState"),
    userRole: localStorage.getItem("userRole"),
    startShiftDate: "",
    startShiftTime: "",
    endShiftDate: "",
    endShiftTime: "",
    startShiftDateProps: "",
    startShiftTimeProps: "",
    endShiftDateProps: "",
    endShiftTimeProps: "",
    staffCanEdit: true,
    staffCanDelete: true,
    staffRequiresSupervision: false,
    filteredByHouseList: [],
    userProgramsList: [],
    userPrograms: localStorage.getItem("userPrograms"),
    usersAllowedPermissionRoles: [],
    userRolesWithPrivilege: [],
    userRolesFilterProgram: [],
    staffFilterRoles: [],
    houses: [],
    updatedByUser: "",
    updatedDate: "",
    updateLogs: [],
    servicecodeListLoader: false,
    isFormFirstTimeOpen: true,
  }),
  async created() {
    this.initializedDateAndTime();
    await this.getHouses();
    await this.initFormData(this.selectedShift);

    if (
      this.userRole === "Shift Lead" ||
      this.userRole === "Direct Care Staff"
    ) {
      this.staffCanEdit = false;
      this.staffCanDelete = false;
    }
  },

  computed: {
    ...mapState({
      selectedShift: (state) => state.shifts.selectedShift,
    }),

    houseErrors() {
      const errors = [];
      if (!this.$v.HouseId.$dirty) return errors;
      !this.$v.HouseId.required && errors.push("House/Unit is required");
      return errors;
    },

    clientErrors() {
      const errors = [];
      if (!this.$v.ClientId.$dirty) return errors;
      !this.$v.ClientId.required && errors.push("Client(s) is required");
      return errors;
    },

    ServiceCodeErrors() {
      const errors = [];
      // if (!this.$v.ServiceCode.$dirty) return errors
      // !this.$v.ServiceCode.required && errors.push('Service is required')
      // return errors
      if (this.isForTraining === "No") {
        if (!this.$v.ServiceCode.$dirty && this.serviceCodes.length > 0)
          return errors;
        if (!this.$v.ServiceCode.required && this.serviceCodes.length > 0) {
          errors.push("Service Code is required");
        }
      }

      return errors;
    },

    resultQueryStaffTraining() {
      if (this.search) {
        return this.availableStaffinTraining.filter((item) => {
          return this.search
            .toLowerCase()
            .split(" ")
            .every((v) => item.Name.toLowerCase().includes(v));
        });
      } else {
        return this.availableStaffinTraining;
      }
    },

    resultQueryStaff() {
      let availableStaff =
        this.isForTraining === "Yes"
          ? this.availableStaffinTraining
          : this.availableStaff;

      if (this.search) {
        return availableStaff.filter((item) => {
          return this.search
            .toLowerCase()
            .split(" ")
            .every((v) => item.Name.toLowerCase().includes(v));
        });
      } else {
        return availableStaff;
      }
    },
  },

  watch: {
    async startDatetime(nval) {
      this.endDateProps = {
        min: moment(new Date(nval)).format("YYYY-MM-DD"),
      };

      if (this.isForTraining === "Yes") {
        await this.getStaffForMeeting(nval, this.endDatetime);
      } else {
        if (this.HouseId) {
          this.HouseName = this.houses
            .filter((house) => house._id === this.selectedShift.houseId)
            .map((house) => house.Name);
        }
        await this.getDefaultStaff(nval, this.endDatetime);
      }
    },

    async endDatetime(nval) {
      //this.getDefaultStaff(this.startDatetime, nval);
      if (this.isForTraining === "Yes") {
        await this.getStaffForMeeting(this.startDatetime, nval);
      } else {
        if (this.HouseId) {
          this.HouseName = this.houses
            .filter((house) => house._id === this.selectedShift.houseId)
            .map((house) => house.Name);
        }
        await this.getDefaultStaff(this.startDatetime, nval);
      }
    },

    async HouseId(val) {
      // To fill automatically of Service Code Selection
      let houseName = "";

      houseName = this.houses
        .filter((house) => house._id === val)
        .map((house) => house.Name);

      if (houseName.toString() !== "") {
        if (this.isFormFirstTimeOpen) {
          houseName.toString() !== this.HouseName.toString()
            ? (this.ClientId = [])
            : (this.ClientId = this.selectedShift.clientId);
          await this.getClientsByUnit(houseName);

          this.isFormFirstTimeOpen = false;
        } else {
          this.ClientId = [];
          await this.getClientsByUnit(houseName);
        }
      }
    },

    ClientId(val) {
      if (val.length == 0) this.ServiceCode = [];
    },

    serviceCodes(val) {
      if (typeof this.ServiceCode === "object") {
        if (val.length > 0) {
          this.ServiceCode = this.ServiceCode.filter((code) => {
            let sc = "";
            val.forEach((item) => {
              if (item.servicecode_id == code.servicecode_id) sc = code;
            });

            if (sc != "") return code;
          });
        }
      }
    },

    /*
    serviceCodes(val) {
      if (
        typeof this.ServiceCode === "object" &&
        Array.isArray(this.ServiceCode)
      ) {
        if (val.length > 0) {
          const validIds = new Set(
            val.map((item) =>
              JSON.stringify({
                client_id: item.client_id,
                servicecode_id: item.servicecode_id,
              })
            )
          );

          this.ServiceCode = this.ServiceCode.filter((code) =>
            validIds.has(
              JSON.stringify({
                client_id: code.client_id,
                servicecode_id: code.servicecode_id,
              })
            )
          );
        }
      }
    },
    */

    isForTraining(val) {
      if (val === "Yes") this.ServiceCode = [];
    },
  },

  methods: {
    ...mapMutations("shifts", {
      setSelectedShift: "SET_SELECTED_SHIFT",
    }),

    isDate(value) {
      return moment(value).isValid();
    },

    formatDate(date) {
      return moment(date).format("MMM Do YYYY, h:mm a"); // Example format
    },

    close() {
      //this.setSelectedShift([]);
      this.$router.push({ path: "/shifts" });
    },

    async getUserRolesPermission() {
      this.isLoading = true;
      await axios
        .get(`${url}/userRolePermission`)
        .then((res) => {
          this.usersAllowedPermissionRoles = res.data.permission;
          this.usersAllowedPermissionRoles.map((allowedRoles) => {
            if (
              allowedRoles.Type === "Shift" &&
              allowedRoles.Description === "showAllProgram"
            ) {
              allowedRoles.AllowedRoles.forEach((role) => {
                this.userRolesWithPrivilege.push(role);
              });
            } else if (
              allowedRoles.Type === "Shift" &&
              allowedRoles.Description === "showFilterProgram"
            ) {
              allowedRoles.AllowedRoles.forEach((role) => {
                this.userRolesFilterProgram.push(role);
              });
            } else if (
              allowedRoles.Type === "Shift" &&
              allowedRoles.Description === "showAllStaff"
            ) {
              allowedRoles.AllowedRoles.forEach((role) => {
                this.staffFilterRoles.push(role);
              });
            }
          });
        })
        .finally(() => (this.isLoading = false));
    },

    async getHouses() {
      await axios
        .get(`${url}/units/state/${this.userState}`)
        .then((response) => {
          response.data.units.forEach((item) => {
            this.houses.push(item);
          });
        });

      // filter by program/house list
      if (this.userRolesWithPrivilege.includes(this.userRole)) {
        this.filteredByHouseList = this.houses;
      } else {
        this.userProgramsList.forEach((program) => {
          this.houses.forEach((house) => {
            if (program === house.Name) {
              if (this.filteredByHouseList.includes(house) === false) {
                this.filteredByHouseList.push(house);
              }
            }
          });
        });
      }
    },

    isDisabledElemsOnStaff() {
      let staffs = ["Direct Care Staff", "Shift Lead"];

      return this.userRole.includes(staffs) ? false : true;
    },

    async showErrorNotification(message) {
      this.updateShift_btn_loader = false;
      Swal.fire({
        title: "Error!",
        text: message,
        icon: "error",
      });
    },

    async showSuccessNotification(message) {
      this.updateShift_btn_loader = false;
      Swal.fire({
        title: "Success!",
        text: message,
        icon: "success",
      });
    },

    async getDefaultStaff(start, end, houseName = this.HouseName) {
      this.isShowing = false;
      let available = [];
      let schedule = [];

      this.availableStaff = [];
      this.scheduledStaff = [];

      await axios
        .get(`${url}/shifts/available/${houseName}/${this.userState}`, {
          params: {
            StartDate: start,
            EndDate: end,
          },
        })
        .then((response) => {
          available = response.data.available;

          if (response.data.schedule !== undefined) {
            response.data.schedule.forEach((item) => {
              if (item.employee != null) {
                if (item.employee.State === this.userState) {
                  const { employee } = item;
                  if (item._id === this.selectedShift.shiftId) {
                    this.staffRequiresSupervision =
                      employee?.RequiresSupervision || "";
                    this.staffName = employee?.Name || "";
                  }
                  schedule.push({
                    _id: item.id,
                    staffName: employee?.Name || "",
                    staffId: employee?._id || "",
                    staffRequiresSupervision:
                      employee?.RequiresSupervision || "",
                  });
                }
              }
            });
          }

          schedule = [
            ...new Map(
              schedule.map((employee) => [employee.staffId, employee])
            ).values(),
          ];
        })
        .finally(() => {
          this.isShowing = true;
          this.isForTraining === "Yes"
            ? (this.availableStaffinTraining = available)
            : (this.availableStaff = available);

          this.scheduledStaff = schedule;
        });
    },

    async initFormData(eventData) {
      this.startShiftDateProps = moment(eventData.utcStartDate).format(
        "YYYY-MM-DD"
      );
      this.startShiftTimeProps = moment(eventData.utcStartDate).format(
        "hh:mm A"
      );
      this.endShiftDateProps = moment(eventData.utcEndDate).format(
        "YYYY-MM-DD"
      );
      this.endShiftTimeProps = moment(eventData.utcEndDate).format("hh:mm A");
      this.startShiftDate = this.startShiftDateProps;
      this.startShiftTime = this.startShiftTimeProps;
      this.endShiftDate = this.endShiftDateProps;
      this.endShiftTime = this.endShiftTimeProps;

      this.StaffId = eventData.staffId;
      this.ClientId = eventData.clientId;
      this.staffSelected = eventData.staffId;
      this.HouseId = eventData.houseId;
      this.ServiceCode =
        eventData.ClientServiceCode !== undefined &&
        eventData.ClientServiceCode.length > 0
          ? eventData.ClientServiceCode
          : eventData.serviceCode;
      this.startDatetime = new Date(eventData.startShift);
      this.endDatetime = new Date(eventData.endShift);
      this.notes = eventData.notes;
      this.task = eventData.task;
      this.status = eventData.status;
      this.isForTraining = eventData.isForTraining;
      this.selectedOption = eventData.selectedOption;
      this.startDateOfRecurringEvent =
        eventData.startDateOfRecurringEvent !== null
          ? moment(new Date(eventData.startDateOfRecurringEvent)).format(
              "YYYY-MM-DD"
            )
          : null;
      this.endDateOfRecurringEvent =
        eventData.endDateOfRecurringEvent !== null
          ? moment(new Date(eventData.endDateOfRecurringEvent)).format(
              "YYYY-MM-DD"
            )
          : null;
      this.isRecurringEvent = eventData.isRecurringEvent;
      if (this.HouseId) {
        this.HouseName = this.houses
          .filter((house) => house._id === this.selectedShift.houseId)
          .map((house) => house.Name);
        if (this.HouseName.toString() !== "")
          await this.getClientsByUnit(this.HouseName);
      }

      this.endDateProps = {
        min: moment(new Date(eventData.startShift)).format("YYYY-MM-DD"),
      };
      this.endTimeProps = {
        min: moment(new Date(eventData.startShift)).format("HH:MM"),
      };

      this.updatedDate =
        eventData.UpdatedDate !== null
          ? moment(new Date(eventData.UpdatedDate)).format("YYYY-MM-DD HH:mm A")
          : null;
      this.updatedByUser = eventData.UpdatedByUser ?? "";
      this.updateLogs = eventData.UpdateLogs ?? [];

      await this.getTasks();
    },

    async getTasks() {
      this.getServiceCodes();

      let timezone = "";

      let startDate = moment_timezone.tz(
        moment().startOf("day").toISOString(),
        timezone
      );
      let endDate = moment_timezone.tz(
        moment().endOf("day").toISOString(),
        timezone
      );

      let clientIds = this.ClientId.map((client) => {
        return client._id != undefined ? client._id : client;
      });

      await axios
        .get(
          `${url}/calendar/tasks?startDate=${startDate}&endDate=${endDate}&client=${clientIds.toString()}`
        )
        .then((response) => {
          this.tasks = response.data.tasks;
        });
    },

    async getServiceCodes() {
      axios.get(`${url}/serviceCodes/client/${this.ClientId}`).then((res) => {
        this.serviceCodes = res.data.serviceCodes.map((item) => {
          let code = {};
          if (typeof this.ServiceCode === "object") {
            code = {
              servicecode_id: item._id,
              servicecode_name: item.ServiceCode,
              client_id: item.client._id,
              client_name: item.client.Name,
            };
          } else {
            code = {
              _id: item.ServiceCode,
              Name: item.ServiceCode,
            };
          }
          return code;
        });
      });
    },

    async getClientsByUnit(houseName) {
      this.clientsUnderSelectedProgram = [];
      await axios
        .get(`${url}/clients/house/${houseName.toString()}`)
        .then((res) => {
          res.data.clients.forEach((item) => {
            this.clientsUnderSelectedProgram.push(item);
          });
        })
        .catch((error) => {
          console.log(error.response.data.msg);
        });

      await this.getDefaultStaff(
        this.startDatetime,
        this.endDatetime,
        houseName
      );
    },

    getStaffForMeeting: async function (start, end) {
      this.isShowing = false;
      let available = [];
      let schedule = [];
      this.scheduledStaffinTraining = [];
      this.availableStaffinTraining = [];
      await axios
        .get(`${url}/shifts/available/${this.userState}`, {
          params: {
            StartDate: start,
            EndDate: end,
          },
        })
        .then(async (res) => {
          available = res.data.available;
          //schedule = res.data.schedule;
          await res.data.schedule.forEach((item) => {
            if (item.employee.State === this.userState) {
              const { employee } = item;
              if (item._id === this.selectedShift.shiftId) {
                this.staffName = employee?.Name || "";
              }

              schedule.push({
                _id: item.id,
                staffName: employee?.Name || "",
                staffId: employee?._id || "",
              });
            }
          });

          schedule = [
            ...new Map(
              schedule.map((employee) => [employee.staffId, employee])
            ).values(),
          ];
        })
        .finally(() => {
          this.isShowing = true;
          this.availableStaffinTraining = available;
          this.scheduledStaffinTraining = schedule;
        });
    },

    /*
    async areArraysEqual(arr1, arr2) {
      if (arr1.length !== arr2.length) return false;

      // Sort arrays by a unique property (e.g., `servicecode_id`)
      const sortedArr1 = [...arr1].sort((a, b) =>
        a.servicecode_id.localeCompare(b.servicecode_id)
      );
      const sortedArr2 = [...arr2].sort((a, b) =>
        a.servicecode_id.localeCompare(b.servicecode_id)
      );

      // Compare objects in sorted arrays
      return sortedArr1.every((obj, index) => {
        const obj2 = sortedArr2[index];
        return JSON.stringify(obj) === JSON.stringify(obj2); // Deep comparison
      });
    },
    */

    async updateScheduleShift() {
      this.updateShift_btn_loader = true;

      // Validate required fields
      if (!this.validateRequiredFields()) {
        this.updateShift_btn_loader = false;
        return;
      }

      this.startDatetime = new Date(
        `${this.startShiftDate} ${this.startShiftTime}`
      );
      this.endDatetime = new Date(`${this.endShiftDate} ${this.endShiftTime}`);

      if (this.$refs.form.validate()) {
        // Validate date range
        if (!this.validateDateRange()) {
          this.updateShift_btn_loader = false;
          return;
        }

        // Validate service code for training
        if (!this.validateServiceCode()) {
          this.updateShift_btn_loader = false;
          return;
        }

        // Construct the request body
        const req_body = this.constructRequestBody();

        // Clone and normalize the original shift for comparison
        const originalShift = await this.normalizeOriginalShift(
          this.selectedShift
        );

        // Detect updated values
        const updatedValues = this.getUpdatedValues(req_body, originalShift);

        // Add update logs to the request body
        req_body["UpdateLogs"] = updatedValues;

        // If no changes detected, notify the user
        if (Object.keys(updatedValues).length === 0) {
          this.updateShift_btn_loader = false;
          this.showErrorNotification("No changes detected.");
          //return;
        }

        // Send the updated data to the server
        try {
          await axios.put(
            `${url}/shifts/${this.selectedShift.shiftId}`,
            req_body
          );
          this.showSuccessNotification("Schedule updated successfully.");
          this.close();
        } catch (err) {
          this.handleError(err);
        } finally {
          this.updateShift_btn_loader = false;
        }
      } else {
        this.updateShift_btn_loader = false;
      }
    },

    // Validate required fields
    validateRequiredFields() {
      if (
        !this.startShiftDate ||
        !this.startShiftTime ||
        !this.endShiftDate ||
        !this.endShiftTime
      ) {
        this.showErrorNotification("Please provide shift start and end dates.");
        return false;
      }
      return true;
    },

    // Validate date range
    validateDateRange() {
      if (moment(this.startDatetime).isSameOrAfter(this.endDatetime)) {
        this.showErrorNotification(
          "Shift End time should be greater than Start time."
        );
        return false;
      }
      return true;
    },

    // Validate service code for non-training scenarios
    validateServiceCode() {
      if (this.isForTraining === "No" && this.$v.ServiceCode.$invalid) {
        if (this.serviceCodes.length > 0) {
          Swal.fire({
            title: "Error!",
            text: "Please select Clients' Service Code.",
            icon: "error",
          });
          return false;
        }
      }
      return true;
    },

    // Construct the request body
    constructRequestBody() {
      const req_body = {
        ClientId: this.ClientId,
        EmployeeId: this.StaffId,
        isTraining: this.isForTraining,
        AvailableStaff: this.staffSelected,
        HouseName: this.HouseName,
        HouseId: this.HouseId,
        StartDate: this.startDatetime,
        EndDate: this.endDatetime,
        Notes: this.notes,
        Task: this.task,
        Status: this.status,
        typeOfRecurringEvent: this.selectedOption,
        tz: moment_timezone.tz.guess(),
      };

      if (typeof this.ServiceCode === "object") {
        req_body.ClientServiceCode = this.ServiceCode;
      } else {
        req_body.ServiceCode = this.ServiceCode;
      }

      return req_body;
    },

    // Normalize the original shift for comparison
    async normalizeOriginalShift(selectedShift) {
      const shift = cloneDeep(selectedShift);
      return {
        ClientId: shift.clientId,
        EmployeeId: shift.staffId,
        AvailableStaff: shift.staffId,
        StartDate: new Date(shift.startShift),
        EndDate: new Date(shift.endShift),
        Notes: shift.notes,
        HouseId: shift.houseId,
        isTraining: shift.isForTraining,
        Status: shift.status,
        HouseName: shift.programName,
        ClientServiceCode: shift.ClientServiceCode,
      };
    },

    // Detect updated values
    getUpdatedValues(req_body, originalShift) {
      const updatedValues = [];

      for (const key in req_body) {
        const oldValue = originalShift[key];
        const newValue = req_body[key];
        if (key === "StartDate" || key === "EndDate") {
          if (originalShift[key].getTime() !== req_body[key].getTime()) {
            updatedValues.push({ field: key, oldValue, newValue });
          }
        } else if (key === "ClientServiceCode" || key === "ClientId") {
          if (!this.areArraysEqual(originalShift[key], req_body[key])) {
            updatedValues.push({ field: key, oldValue, newValue });
          }
        } else {
          if (
            req_body[key] !== originalShift[key] &&
            key !== "HouseName" &&
            key !== "typeOfRecurringEvent" &&
            key !== "tz" &&
            key !== "Task"
          ) {
            updatedValues.push({ field: key, oldValue, newValue });
          }
        }
      }

      return updatedValues;
    },

    // Handle API errors
    handleError(err) {
      if (err.response) {
        this.showErrorNotification(err.response.data.msg);
      } else {
        this.showErrorNotification(
          "An error occurred while updating the schedule."
        );
      }
    },

    // Compare two arrays for equality
    areArraysEqual(arr1, arr2) {
      if (!Array.isArray(arr1) || !Array.isArray(arr2)) return false;
      if (arr1.length !== arr2.length) return false;
      return arr1.every(
        (item, index) => JSON.stringify(item) === JSON.stringify(arr2[index])
      );
    },

    async updateScheduleShift2() {
      this.updateShift_btn_loader = true;
      if (
        !this.startShiftDate ||
        !this.startShiftTime ||
        !this.endShiftDate ||
        !this.endShiftTime
      ) {
        this.showErrorNotification("Please provide shift start and end dates");
        this.updateShift_btn_loader = false;
        return;
      }

      this.startDatetime = new Date(
        `${this.startShiftDate} ${this.startShiftTime}`
      );
      this.endDatetime = new Date(`${this.endShiftDate} ${this.endShiftTime}`);

      if (this.$refs.form.validate()) {
        if (moment(this.startDatetime).isSameOrAfter(this.endDatetime)) {
          this.showErrorNotification(
            "Shift End time should be greater than Start time."
          );
          return false;
        }

        if (this.isForTraining === "No") {
          if (this.$v.ServiceCode.$invalid) {
            // Check if selected client has service code before going to save.
            if (this.serviceCodes.length > 0) {
              this.updateShift_btn_loader = false;
              Swal.fire({
                title: "Error!",
                text: "Please select Clients' Service Code.",
                icon: "error",
              });
              return false;
            }
          }
        }

        let req_body = {
          ClientId: this.ClientId,
          EmployeeId: this.StaffId,
          isTraining: this.isForTraining,
          AvailableStaff: this.staffSelected,
          HouseName: this.HouseName,
          HouseId: this.HouseId,
          StartDate: this.startDatetime,
          EndDate: this.endDatetime,
          Notes: this.notes,
          Task: this.task,
          Status: this.status,
          typeOfRecurringEvent: this.selectedOption,
          // ServiceCode: this.ServiceCode,
          tz: moment_timezone.tz.guess(),
        };

        if (typeof this.ServiceCode === "object") {
          req_body.ClientServiceCode = this.ServiceCode;
        } else {
          req_body.ServiceCode = this.ServiceCode;
        }

        // Create a clone of the selectedShift to ensure it's not frozen
        const originalShift = await { ...this.selectedShift };

        originalShift["ClientId"] = originalShift["clientId"];
        originalShift["EmployeeId"] = originalShift["staffId"];
        originalShift["AvailableStaff"] = originalShift["staffId"];
        originalShift["StartDate"] = new Date(originalShift["startShift"]);
        originalShift["EndDate"] = new Date(originalShift["endShift"]);
        originalShift["Notes"] = originalShift["notes"];
        originalShift["HouseId"] = originalShift["houseId"];
        originalShift["isTraining"] = originalShift["isForTraining"];
        originalShift["Status"] = originalShift["status"];
        originalShift["HouseName"] = originalShift["programName"];

        // Get only updated values by comparing req_body with the original shift data
        const updatedValues = {};
        for (const key in req_body) {
          if (key === "StartDate" || key === "EndDate") {
            if (originalShift[key].getTime() !== req_body[key].getTime()) {
              updatedValues[key] = req_body[key];
            }
          } else if (key === "ClientServiceCode") {
            const result = await this.areArraysEqual(
              originalShift["ClientServiceCode"],
              req_body["ClientServiceCode"]
            );
            if (result === false) {
              updatedValues[key] = req_body[key];
            }
          } else {
            if (
              req_body[key] !== originalShift[key] &&
              key !== "HouseName" &&
              key !== "typeOfRecurringEvent" &&
              key !== "tz" &&
              key !== "Task"
            ) {
              updatedValues[key] = req_body[key];
            }
          }
        }

        req_body["updateLogs"] = { ...updatedValues };

        // If no values have been updated, notify the user and return
        if (Object.keys(updatedValues).length === 0) {
          this.updateShift_btn_loader = false;
          this.showErrorNotification("No changes detected.");
          //return;
        }

        try {
          await axios.put(
            `${url}/shifts/${this.selectedShift.shiftId}`,
            req_body
          );
          this.updateShift_btn_loader = false;
          this.showSuccessNotification("Schedule updated successfully.");
          this.close();
        } catch (err) {
          if (err.response) {
            this.updateShift_btn_loader = false;
            this.showErrorNotification(err.response.data.msg);
          }
        }
      } else {
        this.updateShift_btn_loader = false;
      }
    },

    async publishScheduleShift() {
      this.updateShift_btn_loader = true;

      this.startDatetime = new Date(
        `${this.startShiftDate} ${this.startShiftTime}`
      );
      this.endDatetime = new Date(`${this.endShiftDate} ${this.endShiftTime}`);

      if (this.$refs.form.validate()) {
        this.$v.$touch();

        if (moment(this.startDatetime).isSameOrAfter(this.endDatetime)) {
          this.showErrorNotification(
            "Shift End time should be greater than Start time."
          );
          return false;
        }

        if (this.isForTraining === "No") {
          if (this.$v.ServiceCode.$invalid) {
            // Check if selected client has service code before going to save.
            if (this.serviceCodes.length > 0) {
              this.updateShift_btn_loader = false;
              Swal.fire({
                title: "Error!",
                text: "Please select Clients' Service Code.",
                icon: "error",
              });
              return false;
            }
          }
        }

        var req_body = {
          Status: 1,
          StartDate: this.startDatetime,
          EndDate: this.endDatetime,
          isTraining: this.isForTraining,
          HouseId: this.HouseId,
          EmployeeId: this.StaffId,
          ClientId: this.ClientId,
          AvailableStaff: this.staffSelected,
          Notes: this.notes,
          Task: this.task,
          typeOfRecurringEvent: this.selectedOption,
          // ServiceCode: this.ServiceCode,
          tz: moment_timezone.tz.guess(),
        };

        if (typeof this.ServiceCode === "object") {
          req_body.ClientServiceCode = this.ServiceCode;
        } else {
          req_body.ServiceCode = this.ServiceCode;
        }

        try {
          await axios.put(
            `${url}/shifts/${this.selectedShift.shiftId}`,
            req_body
          );
          this.updateShift_btn_loader = false;
          this.showSuccessNotification("Schedule published successfully.");
          this.close();
        } catch (err) {
          if (err.response) {
            this.updateShift_btn_loader = false;
            this.showErrorNotification(err.response.data.msg);
          }
        }
      }
    },

    async deleteShift(shiftId) {
      Swal.fire({
        title: "Confirm Deleting?",
        text: "Are you sure you want to delete this shift?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.isConfirmed) {
          this.shiftDelete(shiftId);
        }
      });
    },

    async shiftDelete(id) {
      this.delShift_btn_loader = true;
      await axios.delete(`${url}/shifts/${id}`).then((response) => {
        if (response.status === 400) {
          response.json().then(function (data) {
            this.showErrorNotification(data.msg);
          });
        }
        this.delShift_btn_loader = false;
        this.showSuccessNotification(
          "The shift has been deleted successfully."
        );
        this.close();
      });
    },

    initializedDateAndTime() {
      this.startShiftDateProps = moment(this.selectedShift.utcStartDate).format(
        "YYYY-MM-DD"
      );
      this.startShiftTimeProps = moment(this.selectedShift.utcStartDate).format(
        "hh:mm A"
      );
      this.endShiftDateProps = moment(this.selectedShift.utcEndDate).format(
        "YYYY-MM-DD"
      );
      this.endShiftTimeProps = moment(this.selectedShift.utcEndDate).format(
        "hh:mm A"
      );
      this.startShiftDate = this.startShiftDateProps;
      this.startShiftTime = this.startShiftTimeProps;
      this.endShiftDate = this.endShiftDateProps;
      this.endShiftTime = this.endShiftTimeProps;
    },

    isDisabledElementsOnStaff() {
      return this.isDisabledElemsOnStaff ? false : true;
    },

    checkSupervision(staff) {
      if (staff.RequiresSupervision) {
        Swal.fire({
          title: "Confirm Assignment",
          text: "Are you sure you want to assign this staff? The staff's background is still not cleared.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Assign Anyway",
          cancelButtonText: "Choose Other",
        }).then((result) => {
          if (result.isConfirmed) {
            this.staffSelected = staff;
          } else {
            this.staffSelected = this.availableStaff[0];
          }
        });
      } else {
        this.staffSelected = staff;
      }
    },

    async selectedClientServiceCode(id) {
      this.servicecodeListLoader = true;
      this.servicecodesUnderSelectedClient = [];
      await axios
        .get(`${url}/serviceCodes/get/allClientCodes/${id}`)
        .then((res) => {
          this.servicecodesUnderSelectedClient =
            res.data.activeServiceCodes.map((item) => {
              return {
                servicecode_id: item._id,
                servicecode_name: item.ServiceCode,
                servicecode_units: item.Units,
                client_id: item.ClientID._id,
                client_name: item.ClientID.Name,
              };
            });
        })
        .finally(() => (this.servicecodeListLoader = false));
    },

    checkSeletedServiceCode(servicecode) {
      let isTrue = this.ServiceCode.some(
        (code) => code.client_id == servicecode.client_id
      );

      console.log(servicecode);

      if (isTrue) {
        this.ServiceCode = this.ServiceCode.map((code) => {
          if (code.client_id == servicecode.client_id) {
            code.servicecode_id = servicecode.servicecode_id;
            code.servicecode_name = servicecode.servicecode_name;
            code.servicecode_units = servicecode.servicecode_units;
            code.client_id = servicecode.client_id;
            code.client_name = servicecode.client_name;
          }
          return code;
        });
      } else {
        this.ServiceCode.push(servicecode);
      }
    },
  },
};
</script>
<style scoped>
.v-application {
  justify-content: center;
}

.form-size {
  width: 90vw;
  height: 90vh;
  max-width: 100%;
  max-height: 100%;
  overflow: auto;
  margin: auto;
}

@media (max-width: 600px) {
  .form-size {
    width: 100vw;
    height: 100vh;
  }
}
</style>
